var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.999,
    height: 91.999,
    viewBox: "0 0 91.999 91.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12847",
    "data-name": "Group 12847",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_655",
    "data-name": "Ellipse 655",
    cx: 45.5,
    cy: 45.5,
    rx: 45.5,
    ry: 45.5,
    transform: "translate(0 0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12845",
    "data-name": "Group 12845",
    transform: "translate(17.222 21.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11120",
    "data-name": "Path 11120",
    d: "M-410.89,76.75a10.181,10.181,0,0,1-10.18,10.18h-1.437l-16.661-16.661L-455.83,86.93h-1.436a10.181,10.181,0,0,1-10.18-10.18,10.174,10.174,0,0,1,10.18-10.18H-454l.657-2.545A14.617,14.617,0,0,1-435.56,53.461,14.607,14.607,0,0,1-425,64.025l.657,2.545h3.269A10.174,10.174,0,0,1-410.89,76.75Z",
    transform: "translate(467.446 -53.002)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11121",
    "data-name": "Path 11121",
    d: "M-415.5,102.7l-3.744,3.744-8.02-8.02v17.25h-5.294V98.4l-8.031,8.031-3.744-3.744,14.41-14.41Z",
    transform: "translate(458.188 -67.127)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.84a35206a0baeccce32bdbcd54cf717a.svg";
export { ForwardRef as ReactComponent };